export default function (key) {
  if (typeof window.TYPO3 === 'object' && typeof window.TYPO3.lang === 'object' && key in window.TYPO3.lang) {
    return window.TYPO3.lang[key];
  }
  return key;
}
